import { createFileRoute } from '@tanstack/react-router'
import { calendarSearchSchema } from '../../../features/settings/calendar-search'
import { CalendarSection } from '../../../features/settings/calendar-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/calendar')({
  staticData: { crumb: 'settingsSection' },
  validateSearch: calendarSearchSchema,
  beforeLoad: ({ context }) => requireSection(context.session, 'calendar'),
  component: CalendarSection,
})
